import App from "./layout/App";
import Integration from "./layout/integration";
import Account from "./layout/Account";
import { AgencyProvider } from "./context/agency";
import { AuthProvider, useAuthInfo } from "./context/auth";
import AppIframe from "./layout/AppIframe";
import { SSOProvider } from "./context/sso";

const useRoutes = () => {
  const [authSession] = useAuthInfo();
  return [
    {
      key: "app",
      route: "/:companyId/*",
      component: (
        <SSOProvider>
          <AgencyProvider>
            <AuthProvider>
              <App />,
            </AuthProvider>
          </AgencyProvider>
        </SSOProvider>
      ),
      guard: {
        valid: !authSession?.activeAccountId,
        redirect: `/account/${authSession?.companyId}/${authSession?.activeAccountId}/users`,
      },
    },
    {
      key: "account",
      route: "/account/:companyId/:locationId/*",
      component: (
        <SSOProvider>
          <AuthProvider>
            <Account />
          </AuthProvider>
        </SSOProvider>
      ),
    },
    {
      key: "app_iframe",
      route: "/app/iframe/:appId",
      component: <AppIframe />,
    },
    {
      key: "integrations",
      route: "/integrations/*",
      component: <Integration />,
    },
  ];
};

export default useRoutes;
